module.exports = __webpack_public_path__ + "upgrade.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/upgrade.png
// module id = 207
// module chunks = 0